<template>
    <v-container>
        <v-row>
            <v-col
                    cols="12"
            >
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'en' ">About Us</h1>
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'es' ">Sobre Nosotros</h1>
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'pt' ">Sobre Nós</h1>
                <hr>
            </v-col>
            <v-col cols="12" v-if="lang == 'en'" v-html="page.en"></v-col>
            <v-col cols="12" v-if="lang == 'es'" v-html="page.es"></v-col>
            <v-col cols="12" v-if="lang == 'pt'" v-html="page.pt"></v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            lang: { type: String },
            appUrl: { type: String },
            cdnUrl: { type: String },
        },
        metaInfo () {
            return {
                title: 'Best Choice Vacation - About Us',
                meta: [
                    {description: 'Best Choice Vacation - About Us'},
                    {keywords: 'Best Choice Vacation - About Us'}
                ]
            }
        },
        data () {
            return {
                page:{
                    en:"",
                    es:"",
                    pt:"",
                }
            }
        },
        methods:{
        },
        mounted(){
            this.$http.get(this.appUrl+"/store/aboutUs").then(response =>{
                this.page = response.data;
            });
        },
        filters:{

        }
    }
</script>
